if (!window.customElements.get('price-status')) {
  class PriceStatus extends HTMLElement {
    constructor() {
      super();
      this.buyBox = this.closest('product-buybox');
      this.salePercentage = this.querySelector('[data-price-status-sale-percentage]');
      this.dynamicBadge = this.querySelector('[data-price-status-dynamic-badge]');
      this.variants = this.getAttribute('data-variants') ? JSON.parse(this.getAttribute('data-variants')) : null;
    }

    connectedCallback() {
      if (!this.buyBox || !this.variants) return;
      this.buyBox.addEventListener('variantOptionsChanged', (event) => this.handleVariantChange(event.detail));
      this.buyBox.addEventListener('variantUnavailable', () => this.handleUnavailableChange());
    }

    handleVariantChange(detail) {
      const selectedVariant = detail.variant;

      if (!selectedVariant) return;

      const matchingVariant = this.variants.find((variant) => variant.id == selectedVariant.id);

      if (matchingVariant && matchingVariant.price_status != '') {
        const dynamicBadgeClasses = this.dynamicBadge.className.split(' ').filter((c) => !c.startsWith('badge-'));
        this.dynamicBadge.className = dynamicBadgeClasses.join(' ').trim();
        this.dynamicBadge.innerText = matchingVariant.price_status;
        this.dynamicBadge.classList.add(`badge-${matchingVariant.price_status.toLowerCase().replace(/ /g, '-')}`);
        this.dynamicBadge.classList.remove('hidden');
        this.updateSavings(selectedVariant);
      } else {
        this.dynamicBadge.classList.add('hidden');

        if (this.salePercentage) {
          this.salePercentage.classList.add('hidden');
        }
      }
    }

    updateSavings(selectedVariant) {
      if (!this.salePercentage) return;

      if (selectedVariant.comparePrice > selectedVariant.price) {
        const percentOff = 100 - (selectedVariant.price / selectedVariant.comparePrice) * 100;

        if (percentOff >= 3) {
          this.salePercentage.classList.remove('hidden');
          this.salePercentage.innerText = `${percentOff.toFixed(2).split('.')[0]}${this.getAttribute('data-percent-off-text')}`;
        } else {
          this.salePercentage.classList.add('hidden');
        }
      } else {
        this.salePercentage.classList.add('hidden');
      }
    }

    handleUnavailableChange() {
      this.dynamicBadge?.classList.add('hidden');
      this.salePercentage?.classList.add('hidden');
    }
  }

  window.customElements.define('price-status', PriceStatus);
}
